import classNames from "classnames";
import { InfoItem } from "components/DesignSystem/InfoItem/InfoItem";
import { SensitiveDataSection } from "components/SensitiveData/SensitiveDataSection";
import { SENSITIVE_DATA_LINKED_SECTION_TITLE } from "constants/sensitiveData";
import { SensitiveDataLinkedObject } from "types/Models/sensitiveData";
import { getSensitiveDataLinkedRows } from "util/getSensitiveDataLinkedRows";

export const SensitiveDataLinkedSection = ({
  linkedObject,
}: {
  linkedObject?: SensitiveDataLinkedObject;
}) => {
  const rows = getSensitiveDataLinkedRows(linkedObject);

  if (!linkedObject || rows.length === 0) return null;

  return (
    <SensitiveDataSection
      title={SENSITIVE_DATA_LINKED_SECTION_TITLE[linkedObject.type]}
    >
      <div className="t-grid t-grid-cols-2 t-gap-6">
        {rows.map(({ label, value, isFullWidth }) => (
          <InfoItem
            label={label}
            key={label}
            valueClassName="t-text-body"
            className={classNames("t-min-w-0", {
              "t-col-span-2": isFullWidth,
            })}
          >
            {value}
          </InfoItem>
        ))}
      </div>
    </SensitiveDataSection>
  );
};
